<!--
 * @Author: 
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Gaho
 * @LastEditTime: 2024-07-25 16:00:16
 * @Description: 
-->
<template>
    <div class="bg-[#161f2c] flex flex-auto min-w-[30px] h-[30px] items-center justify-center cursor-pointer p-[7px] rounded-lg"
        :class="enable ? buttonStyle.active : buttonStyle.inactive"
        @mouseenter="toolTipModel = true"
        @mouseleave="toolTipModel = false"
        @click.self="() => toolTipModel = false"
    >
        <!-- ↓ 通常接收一个图标 -->
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { buttonStyle } from '~/config/style';

const toolTipModel = ref(false);
defineProps({
    enable: {
        type: Boolean,
        default: false
    },
    toolTip: {
        type: String,
        default: ''
    },
    anchor: {
        type: String,
    },
    self: {
        type: String,
    },
});


</script>
